import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn'; // We'll create a simple cn utility or just use template literals if we don't have clsx/tailwind-merge. Let's just use template literals for simplicity to avoid extra files if not strictly needed, but a utility is cleaner.
// Simple inline utility for class merging
const cx = (...classes: (string | undefined | null | false)[]) => classes.filter(Boolean).join(' ');
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  asChild?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-heading tracking-widest uppercase transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-tx-gold focus:ring-offset-2 focus:ring-offset-tx-primary disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-tx-red text-tx-cream hover:bg-red-700 border border-transparent',
    secondary: 'bg-tx-secondary text-tx-cream hover:bg-tx-border border border-tx-border',
    outline: 'bg-transparent text-tx-cream border-2 border-tx-cream hover:bg-tx-cream hover:text-tx-primary'
  };
  const sizes = {
    sm: 'px-4 py-2 text-lg',
    md: 'px-6 py-3 text-xl',
    lg: 'px-8 py-4 text-2xl'
  };
  return <button ref={ref} className={cx(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-181" />;
});
Button.displayName = 'Button';